import { ErrorBoundary } from '@sentry/react'
import React from 'react'

import { Alert, AlertDescription } from '@/components/ui/alert'

interface Props {
  children: React.ReactNode
  message: React.ReactNode
}

const ErrorBoundaryCard: React.FC<Props> = ({ children, message }) => (
  <ErrorBoundary
    fallback={
      <Alert variant="destructive">
        <AlertDescription>{message}</AlertDescription>
      </Alert>
    }
  >
    {children}
  </ErrorBoundary>
)

export default ErrorBoundaryCard
